// extracted by mini-css-extract-plugin
export default {"wrapper":"OrderNow_wrapper__aPN4T","container":"OrderNow_container__UulRf","list":"OrderNow_list__FNM5T","products":"OrderNow_products__YIXq-"};